export default __webpack_public_path__ + "static/media/ice-cream.4742c144.png";